import window from 'global/window';
import { openLoginModal, openRegistrationModal } from '../../utils';

export const openLink = url => {
  window.open(url, '_self');
};

export const open = (url, regSource, promoCode) => {
  if (url) openLink(url);
  else openRegistrationModal(regSource, promoCode);
};

export const executeAction = (action, url) => {
  switch (action) {
    case 'openLogin':
      openLoginModal();
      break;
    case 'openRegistration':
      openRegistrationModal();
      break;
    case 'openURL':
      open(url);
      break;
    default:
      console.error('Action is not defined');
      break;
  }
};

export const onKeyDown = url => event => {
  if (event.key === 'Space' || event.key === 'Enter') {
    open(url);
  }
};
